import { render, staticRenderFns } from "./CourseBlock.vue?vue&type=template&id=6eca498f&"
import script from "./CourseBlock.vue?vue&type=script&lang=js&"
export * from "./CourseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports